import { render, staticRenderFns } from "./Rollback.vue?vue&type=template&id=cd712a98&"
import script from "./Rollback.vue?vue&type=script&lang=js&"
export * from "./Rollback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports